import { twMerge } from 'tailwind-merge';
import Image from 'next/image';
import { get, isEmpty } from 'lodash';
import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Grid, Pagination } from 'swiper/modules';
import BoxedContainer from '../layouts/BoxedContainer';
import Card from './Card';
import 'swiper/css';
import 'swiper/css/grid';

export default function DiningAndEntertainment({ data, specificData }) {
  const typename = get(data, '__typename', '');
  const background = get(data, 'background.url', '');
  const mobileBackground = get(data, 'mobileBackground.url', '');
  const title = get(data, 'title', '');
  const subtitle = get(data, 'subtitle', '');

  const retails = get(specificData, 'retails', []);
  const places = get(data, 'places', '');

  const simpleIds = places.map((item) => item.id);
  const items = retails
    .filter((item) => simpleIds.includes(item.id))
    .map((item) => {
      const placeData = places.find((place) => place.id === item.id);
      return {
        ...item,
        url: placeData?.url || '',
      };
    });
  const [openIndex, setOpenIndex] = useState(-1);
  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <section data-label={typename} id={typename} className="relative min-h-screen py-12 lg:py-30">
      {!isEmpty(background) && (
        <div className="absolute inset-0 z-0 hidden w-full lg:block">
          <Image
            src={background}
            alt={title || 'Dining background'}
            width={1920}
            height={1080}
            className="h-auto w-full"
            priority
          />
        </div>
      )}

      {!isEmpty(mobileBackground) && (
        <div className="absolute inset-0 z-0 w-full lg:hidden">
          <Image
            src={mobileBackground}
            alt={title || 'Dining background mobile'}
            width={768}
            height={1024}
            className="h-auto w-full"
            priority
          />
        </div>
      )}

      <BoxedContainer className="flex !max-w-408 flex-col">
        <div
          className={twMerge(
            'relative flex flex-col items-center justify-center',
            'z-10 mb-12 text-center text-text-invert lg:mb-16',
          )}>
          {!isEmpty(title) && (
            <h3 className="mb-6 text-clamp28to48 font-medium rtl:font-sans-ar">{title}</h3>
          )}
          {!isEmpty(subtitle) && (
            <p className="text-clamp16to20 font-normal rtl:font-sans-ar">{subtitle}</p>
          )}
        </div>

        {/* Desktop view */}
        <div className="hidden flex-wrap justify-center gap-x-6 gap-y-9 lg:flex lg:justify-center">
          {!isEmpty(items) &&
            [...items]
              .sort((a, b) => {
                const getLastSlug = (url) => {
                  if (!url) return '';
                  const segments = url.split('/').filter(Boolean);
                  const slug = segments[segments.length - 1] || '';
                  return slug.replace(/^\d+\s*/, '').trim();
                };
                const slugA = getLastSlug(a.url).toLowerCase();
                const slugB = getLastSlug(b.url).toLowerCase();
                return slugA.localeCompare(slugB);
              })
              .map((item, index) => (
                <div
                  key={item.id}
                  className="h-[390px] w-full md:w-[calc(50%-0.75rem)] lg:w-[calc(25%-1.125rem)]">
                  <Card
                    data={item}
                    isOpen={openIndex === index}
                    onToggle={() => handleToggle(index)}
                  />
                </div>
              ))}
        </div>
      </BoxedContainer>
      {/* Mobile view */}
      <div className="block lg:hidden ltr:pl-8 rtl:pr-8">
        <Swiper
          slidesPerView={1.5}
          slidesPerGroup={1}
          grid={{
            rows: 2,
            fill: 'row',
          }}
          spaceBetween={24}
          pagination={{
            clickable: true,
          }}
          modules={[Grid, Pagination]}
          className="dining-swiper pb-12">
          {!isEmpty(items) &&
            [...items]
              .sort((a, b) => {
                const getLastSlug = (url) => {
                  if (!url) return '';
                  const segments = url.split('/').filter(Boolean);
                  const slug = segments[segments.length - 1] || '';
                  return slug.replace(/^\d+\s*/, '').trim();
                };
                const slugA = getLastSlug(a.url).toLowerCase();
                const slugB = getLastSlug(b.url).toLowerCase();
                return slugA.localeCompare(slugB);
              })
              .map((item, index) => (
                <SwiperSlide
                  key={item.id}
                  pagination={{
                    el: '.swiper-pagination-custom',
                    clickable: true,
                    bulletClass: 'swiper-pagination-bullet-custom',
                    bulletActiveClass: 'swiper-pagination-bullet-active-custom',
                  }}>
                  <div className="h-[244px]">
                    <Card
                      data={item}
                      isOpen={openIndex === index}
                      onToggle={() => handleToggle(index)}
                    />
                  </div>
                </SwiperSlide>
              ))}
        </Swiper>
      </div>
    </section>
  );
}
